var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "aside-2 ad" }, [
    _c("div", { staticClass: "bd" }, [
      _c(
        "ul",
        _vm._l(_vm.newsList, function(item, index) {
          return _c(
            "li",
            {
              staticClass: "aside-2 ad",
              staticStyle: { display: "list-item" }
            },
            [
              _c(
                "a",
                {
                  attrs: {
                    href: item.items[0].url,
                    target: "_blank",
                    alt: "..."
                  }
                },
                [
                  _c("img", {
                    directives: [
                      {
                        name: "lazy",
                        rawName: "v-lazy",
                        value: {
                          loading: _vm.lazyLoading,
                          error: _vm.lazyLoading,
                          src: item.items[0]["images"][0]["url"]
                        },
                        expression:
                          "{\n                        loading: lazyLoading,\n                        error: lazyLoading,\n                        src: item.items[0]['images'][0]['url']\n                      }"
                      }
                    ]
                  })
                ]
              )
            ]
          )
        })
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-06aea66b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06aea66b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/web/component/web/news-aside/ad-aside.vue
// module id = null
// module chunks = 